import { createContext, useContext, useEffect, useState } from "react";
import { api, setToken, getToken, errMsg } from "@/lib/api";

const Ctx = createContext(null);
export const useAuth = () => useContext(Ctx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(getToken() ? null : false);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return;
    if (!getToken()) return;
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => { setToken(null); setUser(false); });
  }, []);

  const login = async (email, password, register = false, name = "") => {
    try {
      const { data } = await api.post(register ? "/auth/register" : "/auth/login", { email, password, name });
      setToken(data.token);
      setUser(data.user);
      return null;
    } catch (e) {
      return errMsg(e);
    }
  };
  const setSession = (data) => { setToken(data.token); setUser(data.user); };
  const fail = () => { setToken(null); setUser(false); };
  const logout = () => { setToken(null); setUser(false); };
  return <Ctx.Provider value={{ user, login, logout, setSession, fail }}>{children}</Ctx.Provider>;
}
